import posthogInstance from '../packs/posthog';

export default {
  install(Vue, _options) {
    // Vytvořím bezpečnou proxy na PostHog, která ověřuje existenci metod
    const safePosthog = {
      capture: (...args) => posthogInstance?.capture?.(...args),
      identify: (...args) => posthogInstance?.identify?.(...args),
      alias: (...args) => posthogInstance?.alias?.(...args),
      isFeatureEnabled: (key, ...args) => {
        if (!posthogInstance?.isFeatureEnabled) return false;
        try {
          return posthogInstance.isFeatureEnabled(key, ...args);
        } catch (e) {
          return false;
        }
      },
      getFeatureFlag: (key, ...args) => {
        if (!posthogInstance?.getFeatureFlag) return null;
        try {
          return posthogInstance.getFeatureFlag(key, ...args);
        } catch (e) {
          return null;
        }
      },
      getFeatureFlagPayload: (key, ...args) => {
        if (!posthogInstance?.getFeatureFlagPayload) return null;
        try {
          return posthogInstance.getFeatureFlagPayload(key, ...args);
        } catch (e) {
          return null;
        }
      },
      onFeatureFlags: (callback) => {
        if (!posthogInstance?.onFeatureFlags) {
          setTimeout(callback, 0);
          return undefined;
        }

        try {
          return posthogInstance.onFeatureFlags(callback);
        } catch (e) {
          setTimeout(callback, 0);
          return undefined;
        }
      },
      // Forwarding ostatních metod na původní instanci
      __raw: posthogInstance || window.posthog,
    };

    Vue.prototype.$posthog = safePosthog;
  },
};
